import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../home/Navbar";
import healthIcon from "../assets/horoscopeicons/health.png";
import careerIcon from "../assets/horoscopeicons/career.png";
import familyIcon from "../assets/horoscopeicons/family.png";
import financeIcon from "../assets/horoscopeicons/finances.png";
import physiqueIcon from "../assets/horoscopeicons/physique.png";
import relationshipIcon from "../assets/horoscopeicons/relationship.png";
import statusIcon from "../assets/horoscopeicons/status.png";
import totalScoreIcon from "../assets/horoscopeicons/totalscore.png";
import travelIcon from "../assets/horoscopeicons/travel.png";
import friendsIcon from "../assets/horoscopeicons/friends.png";
import Queryform from "./Queryform";
import Footer from "../home/Footer";
import { API_END_POINT } from "./Utils/Constant";

// Zodiac Mapping (Number -> Name)
const zodiacMap = {
  1: "Aries",
  2: "Taurus",
  3: "Gemini",
  4: "Cancer",
  5: "Leo",
  6: "Virgo",
  7: "Libra",
  8: "Scorpio",
  9: "Sagittarius",
  10: "Capricorn",
  11: "Aquarius",
  12: "Pisces",
};

// API Endpoints for each zodiac
const zodiacAPIEndpoints = {
  Aries: `${API_END_POINT}predictions/yearly-aries`,
  Taurus: `${API_END_POINT}predictions/yearly-taurus`,
  Gemini: `${API_END_POINT}predictions/yearly-gemini`,
  Cancer: `${API_END_POINT}predictions/yearly-cancer`,
  Leo: `${API_END_POINT}predictions/yearly-leo`,
  Virgo: `${API_END_POINT}predictions/yearly-virgo`,
  Libra: `${API_END_POINT}predictions/yearly-libra`,
  Scorpio: `${API_END_POINT}predictions/yearly-scorpio`,
  Sagittarius: `${API_END_POINT}predictions/yearly-sagittarius`,
  Capricorn: `${API_END_POINT}predictions/yearly-capricorn`,
  Aquarius: `${API_END_POINT}predictions/yearly-aquarius`,
  Pisces: `${API_END_POINT}predictions/yearly-pisces`,
};

// Horoscope Categories and Icons
const categoryIcons = {
  health: healthIcon,
  career: careerIcon,
  family: familyIcon,
  finances: financeIcon,
  physique: physiqueIcon,
  relationship: relationshipIcon,
  status: statusIcon,
  travel: travelIcon,
  friends: friendsIcon,
};
const zodiacSigns = [
  "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo",
  "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"
];

const YearlyHoroscope = () => {
  const [horoscopeData, setHoroscopeData] = useState(null);
  const [selectedZodiac, setSelectedZodiac] = useState("Aries"); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  // Handle zodiac sign selection
  const handleZodiacSelect = (zodiacSign) => {
    setSelectedZodiac(zodiacSign);
    fetchHoroscope(zodiacSign);
  };

  useEffect(() => {
    
}, []);

  // Handle dropdown selection
  const handleZodiacChange = (event) => {
    const selected = event.target.value;
    setSelectedZodiac(selected);
    fetchHoroscope(selected);
  };

  // Fetch horoscope data when zodiac sign changes
  const fetchHoroscope = async (zodiacSign) => {
    setLoading(true);
    setError(null);

    const apiUrl = zodiacAPIEndpoints[zodiacSign];

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.prediction && data.prediction.response) {
        setHoroscopeData(data.prediction.response);
      } else {
        setError("Invalid API response format.");
        setHoroscopeData(null);
      }
    } catch (error) {
      setError("Failed to load horoscope data.");
      setHoroscopeData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Set initial zodiac sign from location state or default to Aries
    const initialZodiac = location.state?.zodiacSign || "Aries";
    setSelectedZodiac(initialZodiac);
    fetchHoroscope(initialZodiac);
  }, [location.state?.zodiacSign]);

  return (
    <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
      <Navbar />

      {/* Header */}
      <div className="text-center py-6">
        <h1 className="text-4xl font-bold font-serif text-secondary">YEARLY HOROSCOPE</h1>
        <p className="text-lg text-secondary max-w-2xl mx-auto">
          Embrace this yearly horoscope to guide your energy, unlock fresh opportunities, and navigate any challenges that come your way throughout the year.
        </p>
        {/* Zodiac Dropdown (Visible only on small screens) */}
        <div className="sm:hidden px-4 mt-4">
          <label htmlFor="zodiac-select" className="block text-lg font-semibold text-center text-secondary mb-2">
            Select Zodiac Sign:
          </label>
          <select
            id="zodiac-select"
            value={selectedZodiac}
            onChange={handleZodiacChange}
            className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-secondary"
          >
            <option value="">Choose a Zodiac</option>
            {zodiacSigns.map((zodiac, index) => (
              <option key={index} value={zodiac}>
                {zodiac}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Layout: Sidebar + Horoscope Content */}
      <div className="flex flex-col lg:flex-row lg:w-4/5 md:w-4/5 sm:w-full mx-auto gap-6 lg:gap-12">
        {/* Sidebar div (Hidden on small screens) */}
        <aside className="w-full lg:w-1/4 bg-slate-200 shadow-lg p-4 mt-6 h-fit sticky top-2 lg:block hidden">
          <h2 className="text-xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 mb-4">
            Zodiac Signs
          </h2>
          <ul className="space-y-2">
            {zodiacSigns.map((zodiac, index) => (
              <li
                key={index}
                className={`cursor-pointer p-1 rounded-md font-semibold text-center ${
                  zodiac === selectedZodiac 
                    ? 'bg-gradient-to-r from-success to-[#9034E9] text-white' 
                    : 'text-gray-800 hover:bg-gray-200'
                }`}
                onClick={() => handleZodiacSelect(zodiac)}
              >
                {zodiac}
              </li>
            ))}
          </ul>
        </aside>

        {/* Horoscope Content */}
        <div className="lg:w-4/5 w-full p-6">
          {loading ? (
            <p className="text-center text-lg font-bold text-gray-600 py-10">Loading Horoscope Data...</p>
          ) : error ? (
            <p className="text-center text-lg font-bold text-red-500 py-10">{error}</p>
          ) : horoscopeData ? (
            Object.entries(horoscopeData).map(([phaseKey, phase], index) => (
              <div key={index} className="bg-gradient-to-r from-white to-success/40 shadow-lg rounded-lg sm:w-full sm:p-0 md:p-6 mb-6">
                <h2 className="text-2xl font-bold text-center bg-gradient-to-r from-success to-[#9034E9] text-white p-2 rounded-md">
                  {selectedZodiac} - {phase.period} (Phase {index + 1})
                </h2>

                {/* Prediction Summary */}
                <h3 className="text-secondary text-center text-xl font-semibold font-serif mt-2">Phase Summary</h3>
                <p className="text-gray-950 bg-slate-50 text-justify p-5 rounded-md max-w-4xl mx-auto mt-2">{phase.prediction}</p>

                {/* Horoscope Details Grid */}
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 mt-4">
                  {Object.entries(phase).map(([category, details]) => {
                    if (["prediction", "period", "score"].includes(category)) return null;

                    return (
                      <div key={category} className="bg-gray-100 p-4 rounded-md shadow-md flex-row">
                        <div className="flex items-center justify-center rounded-md p-2 bg-gradient-to-r from-success to-[#9034E9] text-white">
                          <img src={categoryIcons[category]} alt={category} className="w-10 h-10 mr-4" />
                          <h3 className="text-xl uppercase font-semibold items-center mt-1">{category.replace("_", " ")}</h3>
                        </div>
                        <div>
                          <p className="text-gray-700 bg-secondary/10 rounded-md p-4 mt-3 text-justify">{details.prediction}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-lg font-bold text-gray-600 py-10">No data available for {selectedZodiac}.</p>
          )}
        </div>
      </div>

      <Queryform />
      <Footer />
    </section>
  );
};

export default YearlyHoroscope;